import { lazy, Suspense, type ReactNode } from 'react';
import { useExerciseLibraryStatus } from '../../hooks/useExerciseLibraryStatus';

const Workspace = lazy(() => import('../../pages/ExerciseLibraryWorkspace'));

function LibraryWithFallback({ fallback, platform }: { fallback: ReactNode; platform: boolean }) {
  const status = useExerciseLibraryStatus();
  if (navigator.onLine) {
    if (status.loading) return <p role="status" className="ui-screen">…</p>;
    if (!status.enabled) return <>{fallback}</>;
  }
  return <Workspace platform={platform} status={status} />;
}

export default function ExerciseLibraryEntry({ fallback, platform = false }: { fallback?: ReactNode; platform?: boolean }) {
  return (
    <Suspense fallback={<p role="status" className="ui-screen">…</p>}>
      {fallback ? <LibraryWithFallback platform={platform} fallback={fallback} /> : <Workspace platform={platform} />}
    </Suspense>
  );
}
